import { Box, Breadcrumbs, Card, CardContent, CardMedia, Container, CssBaseline, Grid, Link, Paper, Stack, Typography, useMediaQuery, useTheme, CardActions } from '@mui/material'
import React, { useContext, useEffect, useState } from 'react'
import TopHeader from '../../../../components/general/TopHeader';
import { Nav, Tab, Tabs } from 'react-bootstrap';
import { NavLink, useLocation } from 'react-router-dom';
import { PvMonitoringContext } from '../../../../context/PvMonitoringContext';
import { PASS_KEY, WEB_KEY } from '../../../../api/AxiosApi';
import DashboardTap4Content from '../dashboard/dashboardTabs/tab4Content/DashboardTap4Content';
import DashboardInverterData from '../dashboard/dashboardTabs/tab5Content/DashboardInverterData';
import DashboardTab6 from '../dashboard/dashboardTabs/tab6ChartContent/DashboardTab6';
import PlantGeneration from '../dashboard/dashboardTabs/tab8ChartContent/PlantGeneration';
import Dashboard7Location from '../dashboard/dashboardTabs/tab7LocationContent/Dashboard7Location';
import DashboardKusumTab1 from './dashboardKusumTabs/DashboardKusumTab1';
import Tab10SldPlant from '../dashboard/dashboardTabs/tab10PlantSld/Tab10PlantSld';
import Enert from "../../../../assets/img/logos/LT2logo.jpeg";
import EventLogReports from '../event_log_reports/EventLogReports';


export default function DashboardKusum() {
    const { palette, typography, breakpoints, spacing } = useTheme()
    const matches = useMediaQuery(breakpoints.up('lg'));


    const [key, setKey] = useState('Main');
    const location = useLocation();
    function handleClick(event) {
        event.preventDefault();
        console.info('You clicked a breadcrumb.');
    }

    

    return (
        <Box sx={{ backgroundColor: "white !important" }}>
            {/* <CssBaseline />
            <TopHeader /> */}
            <Box mt={spacing(0)} sx={{ backgroundColor: "white !important" }}>


                <Tabs
                    style={{ justifyContent: "flex-end", color: "green" }}
                    id="controlled-tab-example"
                    activeKey={key}
                    onSelect={(k) => setKey(k)}
                >



                    <Tab eventKey="Main" title="Main" >

                        {/* <DashboardTap4Content/> */}
                        <DashboardKusumTab1 />
                    </Tab>

                    <Tab eventKey="Event Log" title="Event Log" >
                        <EventLogReports />
                    </Tab>

                    <Tab eventKey="Inverter Details" title="Inverter Details">

                        <DashboardInverterData />
                    </Tab>

                    <Tab eventKey="Peak KW vs KWp" title="Peak KW vs KWp">

                        <DashboardTab6 />
                    </Tab>

                    <Tab eventKey="Plant Generation" title="Plant Generation">
                        <PlantGeneration />
                    </Tab>

                    <Tab eventKey="Plant SLD" title="Plant SLD">
                        <Tab10SldPlant />
                    </Tab>
                </Tabs>
            </Box>
        </Box>

    )
}
